<template>
  <div class="vx-row mb-12">
    <div
      v-bind:class="[
        detail ? detailShow + ' vertical-divider' : '',
        detailHide,
      ]"
    >
      <data-table
        :responseData="responseData"
        :propsParams="params"
        :header="header"
        @reloadDataFromChild="reloadData"
      >
        <template slot="thead">
          <th width="7%">Action</th>
        </template>
        <template slot="tbody">
          <vs-tr
            :key="indextr"
            v-for="(tr, indextr) in responseData.purchasePaymentProposal"
            :class="tr.class"
          >
            <vs-td class="whitespace-no-wrap">
              <template>
                <div class="mt-4 flex justify-between">
                  <vx-tooltip text="Show Invoice" class="mr-4">
                    <vs-button
                      type="line"
                      icon-pack="feather"
                      icon="icon-eye"
                      v-on:click.stop="handleShow(tr)"
                      :disabled="isButtonDisabled"
                    />
                  </vx-tooltip>
                  <!-- <vx-tooltip text="Approve Proposal Payment" class="mr-4">
                <vs-checkbox
                  v-on:click="
                    approve(
                      indextr,
                      data[indextr].dn_id,
                      data[indextr].purchase_return_id
                    )
                  "
                  :checked="dn_id_approve.includes(tr.dn_id)"
                  color="primary"
                ></vs-checkbox>
                </vx-tooltip> -->
                  <vx-tooltip text="Approve Proposal Payment" class="mr-4">
                    <vs-button
                      type="line"
                      icon-pack="feather"
                      icon="icon-check"
                      @click.stop="handleApprove(tr)"
                      :disabled="isButtonDisabled"
                    />
                  </vx-tooltip>
                  <vx-tooltip text="Reject Payment" class="mr-4">
                    <vs-button
                      type="line"
                      color="red"
                      icon-pack="feather"
                      icon="icon-x"
                      v-on:click.stop="handleReject(tr)"
                      :disabled="isButtonDisabled"
                    />
                  </vx-tooltip>
                </div>
              </template>
            </vs-td>
            <vs-td>
              {{ tr.Code }}
            </vs-td>
            <vs-td>
              Code : {{ tr.SupplierCode }}<br />
              Name : {{ tr.SupplierName }}
            </vs-td>
            <vs-td>
              {{ tr.DeliveryNumber }}
            </vs-td>
            <vs-td>
              Code : {{ getDocumentCode(tr) }}<br />
              Total Value :
              {{ priceFormat(getTotalValue(tr)) }}<br />
              Plan Payment Date : {{ dateFormat(tr.PurposePaymentDate) }} <br />
              Type :
              {{ tr.po_type }}
            </vs-td>
            <vs-td> {{ priceFormat(tr.PaidValue) }}<br /> </vs-td>
          </vs-tr>
        </template>
      </data-table>
      <!-- Approve Prompt -->
      <vs-prompt
        title="Confirmation"
        color="primary"
        @accept="doSubmit"
        @cancel="closeDetail"
        @close="closeDetail"
        :buttons-hidden="false"
        :active.sync="approvalPrompt"
      >
        <div class="con-exemple-prompt">
          Proposal Payment
          <br />
          Are you sure to approve <b>{{ this.selectedData.Code }}</b> proposal
          payment ?
          <br />
          <br />
          <vs-textarea v-model="notes" />
        </div>
      </vs-prompt>
      <!-- Reject Prompt -->
      <vs-prompt
        title="Confirmation"
        color="primary"
        @accept="doSubmit"
        @cancel="closeDetail"
        @close="closeDetail"
        :buttons-hidden="false"
        :active.sync="rejectPrompt"
      >
        <div class="con-exemple-prompt">
          Proposal Payment
          <br />
          Are you sure to reject <b>{{ this.selectedData.Code }}</b> proposal
          payment ?
          <br />
          <br />
          <vs-textarea v-model="notes" />
          <!-- <vs-input placeholder="Last Name"  class="w-full" /> -->
        </div>
      </vs-prompt>
    </div>
    <!-- form -->
    <transition name="detail-fade">
      <div
        v-if="detail"
        v-bind:class="[
          detail ? detailShow + 'md:w-2/3 w-full mb-base' : '',
          detailHide,
        ]"
      >
        <vs-row>
          <vs-col
            style="padding-bottom: 8px"
            vs-offset="8"
            vs-type="flex"
            vs-justify="rigth"
            vs-align="rigth"
            vs-w="4"
          >
            <vs-button
              class="ml-auto"
              size="small"
              v-on:click="handleClose"
              color="grey"
              icon-pack="feather"
              icon="icon-x-square"
              >Close</vs-button
            >
          </vs-col>
          <vs-col
            vs-offset="0"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="1"
          >
            <vs-button
              size="small"
              v-on:click="handleClose"
              color="grey"
              icon-pack="feather"
              icon="icon-x-square"
            ></vs-button>
          </vs-col>
          <detail_advance_invoice
            v-if="selectedData && selectedData.po_type === 'Advance Invoice'"
            @close="handleClose"
            :advanceInvoiceID="advanceInvoiceID"
          ></detail_advance_invoice>
          <detail-div v-else @close="handleClose" :selected="selectedData" />
        </vs-row>
      </div>
    </transition>
  </div>
</template>
<script>
import detail from "./detail.vue";
import detail_advance_invoice from "./detail_advance_invoice.vue";
import moment from "moment";
// import { dataPaymentCollection } from "../../../../../services/api/invoice";
export default {
  components: {
    "detail-div": detail,
    detail_advance_invoice,
  },
  props: {
    selected: Object,
    option: Object,
  },
  data() {
    return {
      params: {
        search: "",
        length: 10,
        page: 1,
        order: "desc",
        sort: "id",
      },
      header: [
        {
          text: "Code",
          value: "code",
          // width: '5%'
        },
        {
          text: "Supplier",
          value: "supplier_code",
        },
        {
          text: "No Shipment",
          value: "delivery_number",
        },
        {
          text: "Invoice",
          value: "purchase_invoice_code",
        },
        {
          text: "Value",
          sortable: false,
        },
      ],
      responseData: {},
      detailShow: "vx-col md:w-1/2 w-full mb-base",
      detailHide: "core vx-col md:w-1/1 w-full mb-base",
      detail: false,
      notes: "",
      approveOrReject: false,
      approvalPrompt: false,
      rejectPrompt: false,
      selectedData: {},
      advanceInvoiceID: 0,
      isButtonDisabled: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    // this.reloadData(this.params);
    // this.getData();
    // this.page(1);
    // this.dataId = this.data[0].id
  },
  methods: {
    handleApprove(selected) {
      this.selectedData.class = "";
      this.approveOrReject = 1;
      selected.class = "highlight";
      this.selectedData = selected;
      this.rejectPrompt = false;
      this.approvalPrompt = true;
      console.log(this.selectedData);
    },
    dateFormat(date) {
      console.log(date, "date");
      if (date) {
        return moment(String(date)).format("YYYY-MM-DD");
      }
    },
    handleReject(selected) {
      this.selectedData.class = "";
      this.approveOrReject = 0;
      selected.class = "highlight";
      this.selectedData = selected;
      this.approvalPrompt = false;
      this.rejectPrompt = true;
    },
    doSubmit() {
      this.$vs.loading();
      this.isButtonDisabled = true;
      const params = {
        status: this.approveOrReject,
        propose_id: this.selectedData.ID,
        purchase_invoice_id: this.selectedData.PurchaseInvoiceID,
        cn_supplier_id: this.selectedData.CreditNoteSupplierID,
        advance_invoice_id: this.selectedData.AdvanceInvoiceID,
        notes: this.notes,
      };
      if (!this.approveOrReject && this.notes == "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Notes required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        this.$nextTick(() => {
          this.confirmation = true;
          this.$vs.loading.close();
        });
        return;
      }

      this.$http
        .post("/api/v1/purchase-payment-proposal/change-status", params)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();

            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "error catch",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          console.log(e);
        })
        .finally(() => {
          this.isButtonDisabled = false;
        });
    },
    approve() {
      console.log(this.selectedData);
    },
    closeDetail() {
      this.activePrompt2 = false;
      this.detail = false;
      this.selectedData.class = "";
      this.selectedData = {
        ID: 0,
      };
    },
    dataTable(params) {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/api/v1/purchase-payment-proposal", {
            params: {
              status: 0,
              search: params.search,
              length: params.length,
              page: params.page,
              order: params.sort,
              sort: params.order,
              po_type: "all",
              is_approval: true,
            },
          })
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    handleShow(selected) {
      if (selected.po_type === "Advance Invoice") {
        this.advanceInvoiceID = selected.AdvanceInvoiceID;
      }
      this.selectedData = selected;
      this.selectedData.class = "";
      selected.class = "highlight";
      this.detail = true;
    },
    handleClose() {
      this.reloadData(this.params);
      this.selectedData.class = "";
      this.detail = false;
      this.selectedData = {
        ID: 0,
      };
      this.advanceInvoiceID;
    },
    reloadData(params) {
      this.params = params;
      console.log(params);
      this.$vs.loading();

      const dataTable = this.dataTable(params);
      dataTable.then((r) => {
        console.log(r);
        if (r.code == 500) {
          this.$vs.loading.close();
        } else if (r.code == 200) {
          this.$vs.loading.close();
          this.data = r.data.purchasePaymentProposal;
          this.responseData = r.data;
          this.responseData.length = r.data.purchasePaymentProposal.length;
          // this.checkedAll = false;
        } else {
          this.$vs.loading.close();
        }
      });
    },
    getTotalValue(tr) {
      if (tr.PurchaseInvoiceValue) {
        return tr.PurchaseInvoiceValue;
      } else if (tr.CreditNoteSupplierTotal) {
        return tr.CreditNoteSupplierTotal;
      } else {
        return tr.AdvanceInvoiceTotal;
      }
    },
    getDocumentCode(tr) {
      if (tr.AdvanceInvoiceID) {
        return tr.AdvanceInvoiceCode;
      } else if (tr.CreditNoteSupplierID) {
        return tr.CreditNoteSupplierCode;
      } else {
        return tr.PurchaseInvoiceCode;
      }
    },
  },
};
</script>
<style scoped>
.nonfixed {
  position: inherit;
  padding-left: 20px;
}
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transform-origin-y: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-right: 1px solid #7367f0;
  /* min-height: 800px; */
  /* height: 100%; */
  -webkit-mask-position-y: fixed;
  /* padding: 5px; */
}
.vs-con-table.stripe .tr-values:nth-child(2n) {
  background: beige;
}
.highlight > td {
  background-color: #d0cdf0;
}
.colored {
  border: 1px solid #7367f0;
  position: fixed;
  left: 4%;
  top: 40%;
  max-width: 45%;
  z-index: 999999999999;
  background: antiquewhite;
  background-color: antiquewhite;
}
.vs-dialog {
  max-width: 1000px;
}
</style>
